<script setup>
import LikeButtonComponent from './LikeButtonComponent.vue';
import { useContributorStore } from '@/stores/contributor';

const store = useContributorStore(),
 props = defineProps({
  layout: {
    default: false,
    type: Boolean,
  },
  showImage: {
    default: false,
    type: Boolean,
  },
  contributors: {
    default: () => [],
    type: Array,
  },
}),
 setCurrentContributor = (sector) => {
  store.setContributor(sector);
};
</script>

<template>
  <div>
    <ul
      :class="[
        'list-none mt-4 mb-3',
        props.layout ? 'grid grid-cols-1 md:grid-cols-2 gap-4' : 'grid-cols-1',
      ]"
    >
      <li
        v-for="contributor in props.contributors"
        :key="contributor.id"
        class="border-0 p-0 mb-3 rounded-xl ay-shadow shadow-md bg-white"
      >
        <div
          v-if="props.showImage"
          :class="[
            'card-image-top link-image-preview rounded-t-xl relative overflow-hidden',
            true ? '' : 'hidden',
          ]"
        >
          <router-link
            :to="`/users/${contributor.id}/contributors`"
            target="_self"
            @click="
              setCurrentContributor(contributor)
            "
          >
            <span
              class="ay-overlay overlay-success absolute flex justify-center items-center top-0 bg-teal-950/50 w-full h-full"
              style="z-index: 1"
            />
            <img
              :src="contributor.profile.avatar"
              :alt="contributor.name"
              class="rounded-t-xl w-full ay-img-scaled"
              decoding="async"
              importance="low"
              :title="contributor.name"
              loading="lazy"
            >
          </router-link>
        </div>
        <div class="">
          <div class="flex flex-wrap">
            <div
              class="link-details px-4 pt-4 mb-2 flex justify-between flex-wrap w-full"
            >
              <div class="w-full">
                <h3
                  class="mb-2 h5 text-left overflow-hidden whitespace-nowrap overflow-ellipsis"
                >
                  <router-link
                    :to="`/${contributor?.country.name.toLowerCase()}`"
                    target="_self"
                    class="text-gray-600 font-medium hover:text-blue-600 transition-all"
                    @click="
                      setCurrentContributor(contributor)
                    "
                  >
                    {{ contributor?.country.name }}
                  </router-link>
                </h3>
              </div>
              <div class="items-center flex flex-grow no-more">
                <LikeButtonComponent
                  :id="contributor.id"
                  :count="contributor.likeCount"
                  from="all"
                />
              </div>
              <router-link
                :to="{
                  name: 'UserBusinesses',
                  params: {username: contributor.id},
                }"
                class="tag self-center"
                @click="setCurrentContributor(contributor)"
              >
                <span
                  class="px-1 py-0.5 rounded-sm text-xs font-bold bg-teal-600 text-gray-100"
                >{{ contributor?.country.name }}</span>
              </router-link>
            </div>
            <!--            <hr class="w-full"/>-->
            <!-- <div
                 class="px-4 w-full pt-2 pb-4 hidden xl:flex flex-wrap text-muted">
              <span class="text-xs">jsjkjs / skjskkjs</span>
              <span class="ml-1 text-xs">- etc</span>
            </div> -->
            <div class="w-full px-4 py-3 border-t">
              <div class="flex flex-wrap justify-between items-center text-xs">
                <span class="text-gray-500">
                  {{ contributor?.region.name }}/{{ contributor.city.name }} -
                  {{ contributor.address }}
                </span>

                <div class="flex flex-wrap md:justify-end justify-between items-center">
                  <span class="text-gray-500 mr-md-2"> {{ contributor.updatedAt }} By </span>
                </div>
              </div>
              <!--          <span class="ay-overlay"></span> -->
            </div>
          </div>
        </div>
      </li>
      <!--      <li class="rounded border mb-3 p-1">-->
      <!--        <div class="media-body">-->
      <!--          No Contribution yet.-->
      <!--        </div>-->
      <!--      </li>-->
    </ul>
  </div>
</template>

<style scoped></style>
